var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_vm._v("Loading...")]):_c('div',[(_vm.showError)?_c('h1',[_vm._v("Error")]):_vm._e(),(_vm.showError)?_c('p',[_vm._v("The requested resource could not be found.")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }